import type { IPlanFeatures } from '../services/auth/types';

export const EMPTY_PLAN_FEATURES: IPlanFeatures = {
  indicators: false,
  quotes: false,
  priceComparison: false,
  chat: false,
  myStation: false,
  ai: false,
  stock: false,
};

/**
 * Garante os booleans de planFeatures (defensivo se /users/me vier incompleto).
 * Ausente → tudo false. Não fazer merge com GET /customers/me
 * nem subscriptionPlan.features — isso reintroduz fontes duplas no menu/rotas.
 */
export function normalizePlanFeatures(features?: Partial<IPlanFeatures> | null): IPlanFeatures {
  if (!features) {
    return { ...EMPTY_PLAN_FEATURES };
  }

  return {
    indicators: features.indicators === true,
    quotes: features.quotes === true,
    priceComparison: features.priceComparison === true,
    chat: features.chat === true,
    myStation: features.myStation === true,
    ai: features.ai === true,
    stock: features.stock === true,
  };
}
